<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar tabs scroll-target="#scrolling-activity" style="z-index: 1">
          <v-toolbar-title>{{ $t('devices.devices_title') }}</v-toolbar-title>
          <v-tooltip right>
            <v-btn
              v-if="permits['WATCH_DEVICES']"
              color="gradiente"
              dark
              :small="$vuetify.breakpoint.xsOnly"
              :disabled="flags.startInterval"
              absolute
              bottom
              left
              fab
              slot="activator"
              @click="openAddModal"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <span>{{ $t('devices.add_device') }}</span>
          </v-tooltip>
          <template v-slot:extension>
            <v-tabs
              v-model="tab"
              grow
              color="transparent"
              v-if="permits['WATCH_DEVICES']"
            >
              <v-tabs-slider color="gradiente"></v-tabs-slider>
              <v-tab
                v-for="item in items"
                :key="item.id"
                :style="tab + 1 == item.id ? '' : 'text-decoration: underline;'"
              >
                {{ $t(item.langKey) }}
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <v-container
          fluid
          elevation-2
          style="max-height: 75vh"
          class="scrollDesign"
        >
          <v-layout row wrap>
            <v-flex xs12>
              <v-tabs-items v-model="tab">
                <v-tab-item :key="1">
                  <Ipad
                    v-if="permits['WATCH_DEVICES']"
                    :add="modals.addIpad"
                    :permits="permits"
                    v-on:added="modals.addIpad = false"
                    v-on:startInterval="flags.startInterval = true"
                    v-on:stopInterval="flags.startInterval = false"
                  ></Ipad>
                </v-tab-item>
                <v-tab-item :key="2">
                  <Klipy
                    v-if="permits['WATCH_DEVICES']"
                    :add="modals.addKlipy"
                    :permits="permits"
                    v-on:added="modals.addKlipy = false"
                    v-on:startInterval="flags.startInterval = true"
                    v-on:stopInterval="flags.startInterval = false"
                  ></Klipy>
                </v-tab-item>
                <v-tab-item :key="3">
                  <Ud
                    v-if="permits['WATCH_DEVICES']"
                    :add="modals.addUd"
                    :permits="permits"
                    v-on:added="modals.addUd = false"
                    v-on:startInterval="flags.startInterval = true"
                    v-on:stopInterval="flags.startInterval = false"
                  ></Ud>
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <error v-model="toast.failed" :text="toast.texts.failed"></error>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { isNormalSchool } from '../../../plugins/GeneralMethods'
import error from '../../Dialogs/Error'
import Ipad from '../../Sections/Devices/Ipad'
import Klipy from '../../Sections/Devices/Klipy'
import Ud from '../../Sections/Devices/Ud'
export default {
  components: {
    Ipad,
    Klipy,
    Ud,
    error,
  },
  data: () => ({
    buttonFab: {
      fab: false,
      hidden: false,
    },
    toast: {
      failed: false,
      texts: {
        failed: '',
      },
    },
    tab: null,
    items: [
      {
        id: 1,
        name: 'Ipad',
        langKey: 'devices.ipad',
      },
      {
        id: 2,
        name: 'Tableta Android',
        langKey: 'devices.android_tablet',
      },
    ],
    modals: {
      addIpad: false,
      addUd: false,
      addKlipy: false,
    },
    flags: {
      startInterval: false,
    },
    permits: [],
  }),
  watch: {
    getUser() {
      this.mapPermits()
      if (!this.permits['WATCH_DEVICES']) {
        this.toast.failed = true
        this.toast.texts.failed = 'No autorizado'
      }
    },
    getBranch() {
      if (this.getBranch.id != null) {
        this.setupItemsList()
      }
    },
  },
  mounted() {
    if (this.getUser.id) {
      this.mapPermits()
      if (!this.permits['WATCH_DEVICES']) {
        this.toast.failed = true
        this.toast.texts.failed = 'No autorizado'
      }
    }
    if (this.getBranch.id != null) {
      this.setupItemsList()
    }
  },
  methods: {
    setupItemsList() {
      if (!isNormalSchool(this.getBranch)) {
        this.items = [
          {
            id: 1,
            name: 'Ipad',
            langKey: 'devices.ipad',
          },
        ]
      } else {
        this.items = [
          {
            id: 1,
            name: 'Ipad',
            langKey: 'devices.ipad',
          },
          {
            id: 2,
            name: 'Tableta Android',
            langKey: 'devices.android_tablet',
          },
        ]
      }
    },
    mapPermits() {
      var usr = this.getUser
      var wbRol = usr.webRole
      var catalogs = wbRol.catalogs
      for (var c in catalogs) {
        if (
          catalogs[c].name.includes('DEVICES') ||
          catalogs[c].name.includes('UD') ||
          catalogs[c].name.includes('IPAD') ||
          catalogs[c].name.includes('KLIPY')
        ) {
          this.permits[catalogs[c].name] = 1
        }
      }
      this.$forceUpdate()
    },
    openAddModal() {
      switch (this.tab) {
        case 0:
          if (this.permits['ADD_IPAD']) {
            this.modals.addIpad = true
          } else {
            this.toast.failed = true
            this.toast.texts.failed = 'No autorizado'
          }
          break
        case 1:
          if (this.permits['ADD_IPAD']) {
            this.modals.addKlipy = true
          } else {
            this.toast.failed = true
            this.toast.texts.failed = 'No autorizado'
          }
          break
        case 2:
          if (this.permits['ADD_UD']) {
            this.modals.addUd = true
          } else {
            this.toast.failed = true
            this.toast.texts.failed = 'No autorizado'
          }
          break
      }
    },
  },
  computed: {
    ...mapGetters(['getUser', 'getBranch']),
  },
}
</script>

<style>
.expandableContainer {
  border-style: solid !important;
  border-color: #e6e6e6 !important;
  border-radius: 15px !important;
  border-width: 2px !important;
}
</style>
